export default __webpack_public_path__ + "15efe6fb6b3b451511fa80b9be6faba3.svg";